"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSearchFormPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var services_1 = require("@falcon/services");
var react_datepicker_1 = require("react-datepicker");
var Checkbox_1 = require("../../../components/Checkbox");
var SearchFormBase_1 = require("./SearchFormBase");
var AdvancedSearchFormPanel = /** @class */ (function (_super) {
    __extends(AdvancedSearchFormPanel, _super);
    function AdvancedSearchFormPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchParameters: {
                productId: undefined,
                startDate: undefined,
                endDate: undefined,
                addons: [],
                totalDrivers: undefined,
                premiumType: "",
                tier: "",
                firstYear: undefined,
                amendments: undefined,
                policyStatus: undefined
            },
            loadingQueueSize: 0,
        };
        _this.handleChangeTotalDrivers = _this.handleChangeTotalDrivers.bind(_this);
        _this.handleChangeTier = _this.handleChangeTier.bind(_this);
        _this.handleDateChange = _this.handleDateChange.bind(_this);
        return _this;
    }
    AdvancedSearchFormPanel.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return ((0, jsx_runtime_1.jsxs)("form", { className: "row", onSubmit: this.handleSubmit, autoComplete: "off", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group  col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "startDate", children: "Policy start date" }), (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { id: "startDate", name: "startDate", dateFormat: "yyyy-MM-dd", className: "form-control", minDate: new Date(2020, 0, 1), maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 31), selected: this.state.searchParameters.startDate, showMonthYearDropdown: true, dropdownMode: "select", isClearable: true, onChange: function (date) { return _this.handleDateChange("startDate", date); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group  col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "endDate", children: "Policy end date" }), (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { id: "endDate", name: "endDate", dateFormat: "yyyy-MM-dd", className: "form-control", minDate: new Date(2020, 0, 1), maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 31), selected: this.state.searchParameters.endDate, showMonthYearDropdown: true, dropdownMode: "select", isClearable: true, onChange: function (date) { return _this.handleDateChange("endDate", date); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "productType", children: "Product type" }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "productTypeHome", className: "mt-0 pt-0", name: "Home", label: "Home", value: this.state.searchParameters.productId == services_1.ProductIdEnum.HOME, onChanged: function (value) { return _this.handleProductTypeChange(value, services_1.ProductIdEnum.HOME); } }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "productTypeMotor", className: "mt-0 pt-0", name: "Motor", label: "Car", value: this.state.searchParameters.productId == services_1.ProductIdEnum.WOLF_MOTOR, onChanged: function (value) { return _this.handleProductTypeChange(value, services_1.ProductIdEnum.WOLF_MOTOR); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "premiumType", children: "Premium type" }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "annual", className: "mt-0 pt-0", name: "annual", label: "Annual", value: this.state.searchParameters.premiumType == services_1.AnnualPolicyPremiumTypeEnum.ANNUAL, onChanged: function (value) { return _this.handlePremiumTypeChange(value, services_1.AnnualPolicyPremiumTypeEnum.ANNUAL); } }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "monthly", className: "mt-0 pt-0", name: "monthly", label: "Monthly", value: this.state.searchParameters.premiumType == services_1.AnnualPolicyPremiumTypeEnum.MONTHLY, onChanged: function (value) { return _this.handlePremiumTypeChange(value, services_1.AnnualPolicyPremiumTypeEnum.MONTHLY); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "policyStatus", children: "Policy status" }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "active", className: "mt-0 pt-0", name: "active", label: "Active", value: this.state.searchParameters.policyStatus == "active", onChanged: function (value) { return _this.handlePolicyStatusChange(value, "active"); } }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "cancelled", className: "mt-0 pt-0", name: "cancelled", label: "Cancelled", value: this.state.searchParameters.policyStatus == "cancelled", onChanged: function (value) { return _this.handlePolicyStatusChange(value, "cancelled"); } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "otherProps", children: "Other policy properties" }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "firstYear", className: "mt-0 pt-0", name: "firstYear", label: "First Year", value: (_a = this.state.searchParameters.firstYear) !== null && _a !== void 0 ? _a : false, onChanged: function (value) { return _this.handlePolicyAgeChange(value); } }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "amendments", className: "mt-0 pt-0", name: "amendments", label: "Has MTA", value: (_b = this.state.searchParameters.amendments) !== null && _b !== void 0 ? _b : false, onChanged: function (value) { return _this.handleAmendmentsChange(value); } })] }), this.state.searchParameters.productId && (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "tier", children: "Policy tier" }), (0, jsx_runtime_1.jsx)("select", { id: "tier", className: "form-control", name: "tier", onChange: this.handleChangeTier, children: this.renderTierOptions() })] }), this.state.searchParameters.productId == services_1.ProductIdEnum.WOLF_MOTOR &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "totalDrivers", children: "Total number of drivers" }), (0, jsx_runtime_1.jsx)("select", { id: "totalDrivers", className: "form-control", name: "totalDrivers", onChange: this.handleChangeTotalDrivers, children: this.renderDriverNumberOptions() })] }), this.state.searchParameters.productId && this.renderAddons(), (0, jsx_runtime_1.jsx)("div", { className: "form-group col-12 clearfix", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mr-0 float-right", children: "Search" }) })] }));
    };
    AdvancedSearchFormPanel.prototype.handleDateChange = function (field, date) {
        this.setState(function (state) {
            var _a;
            return ({
                searchParameters: __assign(__assign({}, state.searchParameters), (_a = {}, _a[field] = date, _a))
            });
        });
        this.props.onSearchParameterChange(field, date);
    };
    AdvancedSearchFormPanel.prototype.handleProductTypeChange = function (checked, productId) {
        var _this = this;
        var chosenProduct = checked ? productId : undefined;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { productId: chosenProduct, addons: [] })
            };
        }, function () {
            _this.props.onSearchParameterChange("productId", chosenProduct);
            _this.props.onSearchParameterChange("addons", []);
        });
    };
    AdvancedSearchFormPanel.prototype.handlePremiumTypeChange = function (checked, premiumType) {
        var _this = this;
        var chosenPremiumType = checked ? premiumType : undefined;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { premiumType: chosenPremiumType })
            };
        }, function () {
            _this.props.onSearchParameterChange("premiumType", chosenPremiumType);
        });
    };
    AdvancedSearchFormPanel.prototype.handlePolicyStatusChange = function (checked, policyStatus) {
        var _this = this;
        var chosenStatus = checked ? policyStatus : undefined;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { policyStatus: chosenStatus })
            };
        }, function () {
            _this.props.onSearchParameterChange("policyStatus", chosenStatus);
        });
    };
    AdvancedSearchFormPanel.prototype.handlePolicyAgeChange = function (checked) {
        var _this = this;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { firstYear: checked })
            };
        }, function () {
            _this.props.onSearchParameterChange("firstYear", String(checked));
        });
    };
    AdvancedSearchFormPanel.prototype.handleAmendmentsChange = function (checked) {
        var _this = this;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { amendments: checked })
            };
        }, function () {
            _this.props.onSearchParameterChange("amendments", String(checked));
        });
    };
    AdvancedSearchFormPanel.prototype.handleChangeTotalDrivers = function (event) {
        var _this = this;
        var totalDrivers = event.target.value;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { totalDrivers: totalDrivers })
            };
        }, function () {
            _this.props.onSearchParameterChange("totalDrivers", totalDrivers);
        });
    };
    AdvancedSearchFormPanel.prototype.handleChangeTier = function (event) {
        var _this = this;
        var tier = event.target.value;
        this.setState(function (state) {
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { tier: tier })
            };
        }, function () {
            _this.props.onSearchParameterChange("tier", tier);
        });
    };
    AdvancedSearchFormPanel.prototype.handleAddonChange = function (checked, addon) {
        var _this = this;
        this.setState(function (state) {
            var currentAddons = state.searchParameters.addons || [];
            var nextAddons;
            if (checked) {
                nextAddons = currentAddons.includes(addon) ? currentAddons : __spreadArray(__spreadArray([], currentAddons, true), [addon], false);
            }
            else {
                nextAddons = currentAddons.filter(function (a) { return a !== addon; });
            }
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { addons: nextAddons })
            };
        }, function () {
            _this.props.onSearchParameterChange("addons", _this.state.searchParameters.addons);
        });
    };
    AdvancedSearchFormPanel.prototype.handleBreakdownAddonChange = function (checked, addon) {
        var _this = this;
        this.setState(function (state) {
            var currentAddons = state.searchParameters.addons || [];
            var withoutBreakdowns = currentAddons.filter(function (addon) { return !addon.startsWith("BREAKDOWN"); });
            var nextAddons;
            if (checked) {
                nextAddons = __spreadArray(__spreadArray([], withoutBreakdowns, true), [addon], false);
            }
            else {
                nextAddons = withoutBreakdowns;
            }
            return {
                searchParameters: __assign(__assign({}, state.searchParameters), { addons: nextAddons })
            };
        }, function () {
            _this.props.onSearchParameterChange("addons", _this.state.searchParameters.addons);
        });
    };
    AdvancedSearchFormPanel.prototype.renderDriverNumberOptions = function () {
        var options = ["1", "2", "3", "4", "5"];
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Select total number of drivers" }), options.map(function (option) {
                    return ((0, jsx_runtime_1.jsx)("option", { value: option, children: option }, option));
                })] }));
    };
    AdvancedSearchFormPanel.prototype.renderTierOptions = function () {
        var options = this.state.searchParameters.productId == services_1.ProductIdEnum.HOME
            ? Object.values(services_1.HomeCoverTier)
            : Object.values(services_1.MotorCoverTier);
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Select policy tier" }), options.map(function (option) {
                    return ((0, jsx_runtime_1.jsx)("option", { value: option, children: option }, option));
                })] }));
    };
    AdvancedSearchFormPanel.prototype.renderAddons = function () {
        var _this = this;
        var searchParameters = this.state.searchParameters;
        var addons = (searchParameters.productId === services_1.ProductIdEnum.HOME
            ? services_1.HomeAddons
            : services_1.MotorAddons);
        var addonOptions = Object.keys(addons).map(function (key) { return ({
            key: key,
            label: addons[key],
        }); });
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12 col-md-6", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "addons", children: "Addons" }), addonOptions.map(function (_a) {
                    var _b, _c;
                    var key = _a.key, label = _a.label;
                    var value = (_c = (_b = searchParameters.addons) === null || _b === void 0 ? void 0 : _b.includes(key)) !== null && _c !== void 0 ? _c : false;
                    return ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: key, name: key, label: label, className: "mt-0 pt-0", value: value, onChanged: function (checked) {
                            if (key.includes("BREAKDOWN")) {
                                _this.handleBreakdownAddonChange(checked, key);
                            }
                            else {
                                _this.handleAddonChange(checked, key);
                            }
                        } }, key));
                })] }));
    };
    AdvancedSearchFormPanel = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], AdvancedSearchFormPanel);
    return AdvancedSearchFormPanel;
}(SearchFormBase_1.SearchFormBase));
exports.AdvancedSearchFormPanel = AdvancedSearchFormPanel;
//# sourceMappingURL=AdvancedSearchFormPanel.js.map